export var isMonth = function (thing) {
    return typeof thing === 'number' && thing >= 1 && thing <= 12;
};
